<p>property-stats works!</p>
